import { colors, COLORS } from '@constants/colors';

export const useInspectorStyles = () => ({
  section: {
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  sectionLabel: {
    color: colors.white_50,
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    padding: '0 4px',
  },

  fieldLabel: {
    color: colors.white_60,
    fontSize: '12px',
    fontWeight: 500,
    padding: '0 4px',
    marginBottom: '4px',
  },

  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.04)',
      borderRadius: '8px',
      color: COLORS.WHITE,
      fontSize: '13px',
      '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.1)' },
      '&:hover fieldset': { borderColor: 'rgba(255, 255, 255, 0.18)' },
      '&.Mui-focused fieldset': { borderColor: COLORS.MYTAVERSE_BLUE },
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 10px',
    },
  },

  colorRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '6px 8px',
    borderRadius: '8px',
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.03)',
    },
  },
  colorSwatch: {
    width: 26,
    height: 26,
    borderRadius: '6px',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    cursor: 'pointer',
    flexShrink: 0,
    transition: 'transform 0.15s ease, border-color 0.15s ease',
    '&:hover': {
      transform: 'scale(1.04)',
      borderColor: 'rgba(255, 255, 255, 0.32)',
    },
  },
  colorRowText: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
  },
  colorRowLabel: {
    color: COLORS.WHITE,
    fontSize: '13px',
    fontWeight: 500,
  },
  colorRowHex: {
    color: colors.white_50,
    fontSize: '11px',
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
  },

  pickerPopover: {
    backgroundColor: 'rgba(20, 20, 24, 0.97)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(16px)',
    borderRadius: '12px',
    padding: '12px',
  },
  pickerHexField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.04)',
      borderRadius: '8px',
      color: COLORS.WHITE,
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
      fontSize: '13px',
      '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.1)' },
      '&:hover fieldset': { borderColor: 'rgba(255, 255, 255, 0.18)' },
      '&.Mui-focused fieldset': { borderColor: COLORS.MYTAVERSE_BLUE },
    },
    '& .MuiOutlinedInput-input': {
      padding: '6px 10px',
      textAlign: 'center',
    },
  },

  helperError: {
    color: '#FF6B6B',
    fontSize: '11px',
    padding: '0 4px',
  },

  spotPreview: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px',
    borderRadius: '10px',
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
  },
  spotThumb: {
    width: 44,
    height: 44,
    borderRadius: '8px',
    overflow: 'hidden',
    flexShrink: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.white_40,
    position: 'relative',
  },
  spotThumbClickable: {
    cursor: 'zoom-in',
    transition: 'transform 0.15s ease',
    '&:hover': {
      transform: 'scale(1.04)',
    },
    '&:hover .spot-thumb-expand': {
      opacity: 1,
    },
  },
  spotThumbExpandHint: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    color: COLORS.WHITE,
    opacity: 0,
    transition: 'opacity 0.15s ease',
    pointerEvents: 'none',
  },
  spotThumbVideoBadge: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.32)',
    color: COLORS.WHITE,
    pointerEvents: 'none',
  },
  spotThumbPlaceholder: {
    background:
      'repeating-linear-gradient(45deg, rgba(58,58,70,1) 0px, rgba(58,58,70,1) 8px, rgba(46,46,58,1) 8px, rgba(46,46,58,1) 16px)',
  },
  spotFilename: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  spotFilenameText: {
    color: COLORS.WHITE,
    fontSize: '13px',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  spotFilenameMeta: {
    color: colors.white_50,
    fontSize: '11px',
  },

  mediaCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '10px 12px',
    borderRadius: '14px',
    backgroundColor: 'rgba(255, 255, 255, 0.045)',
    border: '1px solid rgba(255, 255, 255, 0.12)',
  },

  compactRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  compactThumb: {
    width: 44,
    height: 44,
    borderRadius: '10px',
    overflow: 'hidden',
    flexShrink: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.white_40,
    position: 'relative',
  },
  compactInfo: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  compactTitle: {
    color: COLORS.WHITE,
    fontSize: '13px',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  compactSubtitle: {
    color: colors.white_50,
    fontSize: '11px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  compactActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    flexShrink: 0,
  },
  iconSquareButton: {
    width: 32,
    height: 32,
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    color: COLORS.WHITE,
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.32)',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.32)',
      borderColor: 'rgba(255, 255, 255, 0.1)',
      backgroundColor: 'rgba(255, 255, 255, 0.03)',
    },
  },
  iconDangerButton: {
    '&:hover': {
      borderColor: '#FF6B6B',
      color: '#FF6B6B',
      backgroundColor: 'rgba(255, 107, 107, 0.06)',
    },
  },
  compactDivider: {
    height: '1px',
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    margin: '2px 0',
  },
  thumbExpandBadge: {
    position: 'absolute',
    bottom: 3,
    right: 3,
    width: 16,
    height: 16,
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    color: COLORS.WHITE,
    pointerEvents: 'none',
  },
  progressBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  progressTextRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    minHeight: 14,
  },
  compactProgressBar: {
    height: 3,
    borderRadius: '99px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    '& .MuiLinearProgress-bar': {
      borderRadius: '99px',
      backgroundColor: COLORS.MYTAVERSE_BLUE,
    },
  },
  previewStatusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minWidth: 0,
  },
  previewStatusOk: {
    color: '#4CCBA0',
  },
  previewStatusRequired: {
    color: '#FF6B6B',
  },
  uploadErrorText: {
    color: '#FF6B6B',
    fontSize: '11px',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  uploadErrorBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '6px',
    backgroundColor: 'rgba(255, 107, 107, 0.1)',
    border: '1px solid rgba(255, 107, 107, 0.32)',
    borderRadius: '8px',
    padding: '6px 10px',
  },
  uploadErrorBannerText: {
    color: '#FF6B6B',
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: 1.35,
    wordBreak: 'break-word',
  },
  cancelUploadButton: {
    marginLeft: 'auto',
    fontSize: '11px',
    fontWeight: 600,
    color: '#AEB6FF',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    '&:hover': { textDecoration: 'underline' },
  },
  mediaThumb: {
    width: 84,
    height: 68,
    borderRadius: '12px',
    overflow: 'hidden',
    flexShrink: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.white_40,
    position: 'relative',
  },
  mediaThumbVideo: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  mediaInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    flex: 1,
    minWidth: 0,
  },
  mediaTitle: {
    color: COLORS.WHITE,
    fontSize: '13px',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  mediaSubtitle: {
    color: colors.white_50,
    fontSize: '11px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  mediaActionsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginTop: '4px',
  },
  mediaActionButton: {
    flex: 1,
    color: COLORS.WHITE,
    borderColor: 'rgba(255, 255, 255, 0.18)',
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    textTransform: 'none',
    padding: '5px 8px',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: 600,
    minWidth: 0,
    gap: '4px',
    whiteSpace: 'nowrap',
    lineHeight: 1.2,
    '& .MuiButton-startIcon': {
      marginRight: '4px',
      marginLeft: 0,
    },
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.32)',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.72)',
      borderColor: 'rgba(255, 255, 255, 0.16)',
      backgroundColor: 'rgba(255, 255, 255, 0.06)',
      opacity: 1,
    },
  },
  mediaProgressRow: {
    display: 'grid',
    gridTemplateColumns: '13px minmax(0, 1fr) 58px',
    alignItems: 'center',
    gap: '7px',
    minHeight: 18,
  },
  mediaProgress: {
    height: 3,
    borderRadius: '99px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    '& .MuiLinearProgress-bar': {
      borderRadius: '99px',
      backgroundColor: COLORS.MYTAVERSE_BLUE,
    },
  },

  spotActionsRow: {
    display: 'flex',
    gap: '8px',
    marginTop: '4px',
  },
  spotActionButton: {
    flex: 1,
    color: COLORS.WHITE,
    borderColor: 'rgba(255, 255, 255, 0.18)',
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    textTransform: 'none',
    padding: '6px 10px',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: 500,
    gap: '4px',
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.32)',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.72)',
      borderColor: 'rgba(255, 255, 255, 0.16)',
      backgroundColor: 'rgba(255, 255, 255, 0.06)',
      opacity: 1,
    },
  },
  spotDeleteButton: {
    minWidth: 36,
    flex: '0 0 36px',
    padding: '6px',
    color: colors.white_60,
    borderColor: 'rgba(255, 255, 255, 0.18)',
    '&:hover': {
      borderColor: '#FF6B6B',
      color: '#FF6B6B',
      backgroundColor: 'rgba(255, 107, 107, 0.06)',
    },
  },

  segmented: {
    display: 'flex',
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    borderRadius: '8px',
    padding: '3px',
    gap: '2px',
  },
  segmentedItem: {
    flex: 1,
    padding: '6px 10px',
    fontSize: '12px',
    fontWeight: 500,
    color: colors.white_60,
    cursor: 'pointer',
    borderRadius: '6px',
    textAlign: 'center',
    transition: 'background-color 0.15s ease, color 0.15s ease',
    '&:hover': {
      color: COLORS.WHITE,
    },
  },
  segmentedItemActive: {
    backgroundColor: COLORS.MYTAVERSE_BLUE,
    color: COLORS.WHITE,
    '&:hover': {
      color: COLORS.WHITE,
    },
  },
  segmentedItemDisabled: {
    cursor: 'not-allowed',
    opacity: 0.4,
    pointerEvents: 'none',
  },
  segmentedItemLocked: {
    cursor: 'default',
    pointerEvents: 'none',
  },

  conversionRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) 64px',
    alignItems: 'center',
    gap: '10px',
    padding: '5px 8px',
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
  },
  conversionText: {
    color: colors.white_60,
    fontSize: '11px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  identifierField: {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    fontSize: '12px',
  },

  /* Video upload dropzones — stacked vertically for narrow inspector */
  videoDropzoneGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  videoDropzone: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    border: '1px dashed rgba(255, 255, 255, 0.18)',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'background-color 0.15s ease, border-color 0.15s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.06)',
      borderColor: 'rgba(255, 255, 255, 0.32)',
    },
  },
  videoDropzoneText: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    gap: '2px',
  },
  videoDropzoneActive: {
    borderColor: COLORS.MYTAVERSE_BLUE,
    backgroundColor: 'rgba(69, 84, 229, 0.1)',
  },
  videoDropzoneIcon: {
    fontSize: 22,
    color: colors.white_40,
    flexShrink: 0,
  },
  videoDropzoneLabel: {
    fontSize: '12px',
    color: COLORS.WHITE,
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
  videoDropzoneAction: {
    fontSize: '11px',
    color: COLORS.MYTAVERSE_BLUE,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },
  videoDropzoneSubtitle: {
    fontSize: '11px',
    color: colors.white_50,
    fontWeight: 400,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  videoDropzoneRequired: {
    color: '#FF6B6B',
  },
  videoConfirmRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '4px',
  },
  videoConfirmButton: {
    color: COLORS.WHITE,
    backgroundColor: COLORS.MYTAVERSE_BLUE,
    textTransform: 'none',
    padding: '6px 14px',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: 500,
    boxShadow: 'none',
    '&:hover': { backgroundColor: '#3A46C1', boxShadow: 'none' },
    '&.Mui-disabled': {
      backgroundColor: 'rgba(69, 84, 229, 0.35)',
      color: 'rgba(255, 255, 255, 0.55)',
    },
  },

  distanceHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
    padding: '0 4px',
  },
  distanceInfiniteToggle: {
    margin: 0,
    color: colors.white_60,
    '& .MuiTypography-root': {
      fontSize: '11px',
      fontWeight: 500,
      color: colors.white_60,
    },
    '& .MuiSwitch-root': {
      marginRight: '4px',
    },
  },
  infiniteLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
  },
  infiniteSymbol: {
    fontSize: '14px',
    fontWeight: 700,
    color: colors.white_60,
    lineHeight: 1,
  },
  infiniteText: {
    fontSize: '11px',
    fontWeight: 500,
    color: colors.white_60,
  },
  distanceSliderRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '0 6px',
  },
  distanceSlider: {
    flex: 1,
    color: COLORS.MYTAVERSE_BLUE,
    '& .MuiSlider-thumb': {
      backgroundColor: COLORS.WHITE,
    },
    '& .MuiSlider-rail': {
      opacity: 0.3,
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
    },
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.25)',
    },
  },
  distanceValue: {
    minWidth: 38,
    textAlign: 'right',
    color: COLORS.WHITE,
    fontSize: '12px',
    fontWeight: 600,
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
  },

  assistantSection: {
    marginTop: '14px',
    padding: '10px',
    borderRadius: '10px',
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  assistantSectionText: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  assistantSectionTitle: {
    color: COLORS.WHITE,
    fontSize: '13px',
    fontWeight: 600,
  },
  assistantSectionSubtitle: {
    color: colors.white_50,
    fontSize: '11px',
  },
  assistantSectionButton: {
    color: COLORS.WHITE,
    borderColor: 'rgba(255, 255, 255, 0.2)',
    textTransform: 'none',
    padding: '4px 12px',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    minWidth: 'unset',
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.35)',
      backgroundColor: 'rgba(255, 255, 255, 0.04)',
    },
  },

  /* Image lightbox */
  lightboxBackdrop: {
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.78)',
    },
  },
  lightboxImg: {
    maxWidth: '90vw',
    maxHeight: '88vh',
    objectFit: 'contain',
    borderRadius: '8px',
    display: 'block',
  },
  lightboxClose: {
    position: 'absolute',
    top: 14,
    right: 14,
    color: COLORS.WHITE,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.6)' },
  },

  emptyHint: {
    color: colors.white_40,
    fontSize: '12px',
    padding: '12px 8px',
    textAlign: 'center',
    fontStyle: 'italic',
  },

  liveWarning: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: 'rgba(255, 184, 0, 0.1)',
    border: '1px solid rgba(255, 184, 0, 0.32)',
    borderRadius: '8px',
    padding: '6px 10px',
    margin: '6px 0',
  },
  liveWarningText: {
    color: '#FFB800',
    fontSize: '11px',
    fontWeight: 500,
  },

  /* Map editor — the ordered room chain and its publish controls */
  mapEditorRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px',
    borderRadius: '10px',
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    marginBottom: '6px',
  },
  // Position in the chain, not a count — monospaced and tabular so the numbers stay
  // aligned as the list crosses from single to double digits while rooms are reordered.
  mapEditorRowIndex: {
    color: colors.white_40,
    fontSize: '11px',
    fontWeight: 700,
    minWidth: '18px',
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    fontVariantNumeric: 'tabular-nums',
  },
  // A grid of equal columns rather than a flex row. Flex was giving each action a different width:
  // its items floor at min-content, so every button's own label and padding pushed back against
  // flex-basis, and Save's wider padding made it the widest of the three. `minmax(0, 1fr)` has no
  // such floor, so the columns are equal by construction whatever the labels say — and auto-flow
  // means a fourth action would not need the count changed here.
  mapEditorFooter: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: 'minmax(0, 1fr)',
    gap: '8px',
    marginTop: '12px',
    paddingTop: '12px',
    borderTop: '1px solid rgba(255, 255, 255, 0.08)',
    // The shared button styles set a min-width for standalone use; inside a fixed column it would be
    // the one thing able to overflow it.
    '& button': {
      minWidth: 0,
      width: '100%',
    },
  },
  // For a footer action that needs a wrapper: a Tooltip has to hand its ref to a real element, and a
  // disabled MUI button fires no events for it to hook. Stretches so the button fills its column
  // instead of sizing to its label.
  mapEditorFooterAction: {
    display: 'flex',
  },
  mapEditorSaveButton: {
    flex: 1,
    color: COLORS.WHITE,
    backgroundColor: COLORS.MYTAVERSE_BLUE,
    textTransform: 'none',
    padding: '6px 14px',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: 600,
    boxShadow: 'none',
    '&:hover': { backgroundColor: '#3A46C1', boxShadow: 'none' },
    '&.Mui-disabled': {
      backgroundColor: 'rgba(69, 84, 229, 0.35)',
      color: 'rgba(255, 255, 255, 0.55)',
    },
  },
  // Unsaved is information, not a fault — it uses the brand blue rather than the amber
  // liveWarning treatment, which is reserved for things that are actually wrong.
  mapEditorUnsavedBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: 'rgba(69, 84, 229, 0.12)',
    border: '1px solid rgba(69, 84, 229, 0.4)',
    borderRadius: '8px',
    padding: '6px 10px',
    margin: '10px 0 0',
  },
  mapEditorUnsavedText: {
    color: '#AEB6FF',
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: 1.35,
  },
  mapEditorNote: {
    color: colors.white_50,
    fontSize: '11px',
    lineHeight: 1.5,
    marginTop: '10px',
    padding: '0 4px',
  },
});
